import { Type } from "class-transformer";
import { Product } from "./product.model";

export class HealthInsurance {
  id: string = null;
  dossierId: string = null;
  vhiInsurer: any = null;
  vhiAlarmcenter: string = null;
  vhiHealthInsuranceNumber: string = null;
  @Type(() => Date) vhiDateofBirth: Date = null;
  vhiInsurerPhonenumber: string = null;
  vhiStatusPolisCheck: string = null;
  vhiTypePolicyCheck: string = null;
  vhiComments: string = null;
  vhiIsManual: boolean = false;
  vhiBsn: string;
  vhiPolicyType: string;
  vhiProductType: string;
  vhiPolicyCode: string;
  vhiPolicyName: string;
  vhiUzovi: string;
  vhiOtherAlarmCenter: string;
  vhiDatePolicyCheck: string;
  isSelected: boolean;
  vhiProductId: string;
  vhiInsuranceCoverageId: string;
  vhiPersonName: string;
  vhiReferenceDate: Date = null;
  vhiClient:any;
  vhiMAlarmcenter:any;
  vhiChargedExpenses:any;
  vhiServiceFees:any;
  assignmentId:string = null;
  coveredPerson : string ;
  vhiStartDate: string;
  vhiEndDate: string;
  product:Product;
}